<template lang="pug">
.listing-app
	transition(name="fadeIn")
		Loader(v-if="loading || error")
		.listing-app__inner(v-else)
			StyledListing(v-if="topStyledListing", :listing="topStyledListing")
			Filters(v-if="useFilters")
			h2.listing-app__heading(v-if="headingText && headingText.length > 0") {{ headingText }}
			.listing-app__list(:class="{ narrow: narrowWidth }")
				Listing(v-for="(listing, i) in filteredListings", :listing="listing", :key="listing.id", v-if="showListingLogic(i)")
			.listing-app__footer(v-if="showFooter", :class="{ narrow: narrowWidth }")
				LoadMore(v-if="useLoadMore", v-show="showLoadMore")
				Pagination(v-else)
			p.listing-app__no-results(v-if="!showFooter") {{ noResultsMsg }}
	Listing
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Loader from "./components/generic/Loader";
import Filters from "./components/Filters";
import StyledListing from "./components/StyledListing";
import Listing from "./components/Listing";
import LoadMore from "./components/LoadMore";
import Pagination from "./components/Pagination";

export default {
  name: "ListingApp",
	components: {
		Loader,
		Filters,
		StyledListing,
		Listing,
		LoadMore,
		Pagination
	},
  data: function () {
    return {
      headingText: this.$root.mainHeading,
			listingCount: null,
			currentListings: null,
			noResultsMsg: this.$root.noResults
    };
  },
  computed: {
		...mapGetters(["loading", "error", "listingsData", "activeListingCount", "currentPage", "filteredListings", "filterTags", "topStyledListing"]),
		useFilters() {
			return this.$root.filters === "true";
		},
		narrowWidth() {
			return this.$root.narrowList === "true";
		},
		useLoadMore() {
			// Use LoadMore (rather than Pagination) component if declared in data attribute
			return this.$root.loadMore === "true" && (this.$root.pagination === "false" || !this.$root.pagination);
		},
		showLoadMore() {
			// Display LoadMore component if the listingsData returns a non-empty array and if there are still more listings left to load
			return this.listingsData.listings.length > 0 && this.activeListingCount < this.listingsData.listings.length
		},
		showFooter() {
			if (this.filterTags && this.filterTags.length > 0 && this.filteredListings && this.filteredListings.length === 0) {
				return false;
			} else {
				return true;
			}
		}
	},
  methods: {
		...mapActions(["loadListingsData", "setActiveListingCount", "setFilterTags", "setFilteredListings", "setTopStyledListing", "setNavigableListings"]),
		getListingsData() {
			if (this.$root.listingFilters && this.$root.listingFilters.length > 0) {
				let query = "?listingFilters=" + this.$root.listingFilters;
				this.loadListingsData(this.$root.listingsEndpoint + query);
			} else {
				this.loadListingsData(this.$root.listingsEndpoint);
			}
		},
		setTopListingData() {
			if (this.$root.topListingStyles == "true") {
				let styledListing = this.listingsData.listings[0];
				this.setTopStyledListing(styledListing);
				let navigableListings = this.listingsData.listings.slice(1, this.listingsData.listings.length);
				this.setNavigableListings(navigableListings);
			} else {
				this.setNavigableListings(this.listingsData.listings);
			}
		},
		showListingLogic(index) {
			if (this.useLoadMore) {
				return index < this.activeListingCount
			} else {
				return (index < this.currentPage * this.listingCount && index >= (this.currentPage - 1) * this.listingCount)
			}
		}
	},
	created() {
		this.getListingsData();
		this.setActiveListingCount(parseInt(this.$root.listingCount));
		this.listingCount = parseInt(this.$root.listingCount);
	},
	updated() {
		if (this.filteredListings == null) {
			this.setTopListingData();
			this.setFilteredListings();
		}
	}
};
</script>

<style lang="scss">
.fadeIn-enter-active,
.fadeIn-leave-active {
  transition: opacity 0.75s;
}
.fadeIn-enter, .fadeIn-leave-to {
  opacity: 0;
}
.fadeIn-leave-to {
  position: absolute;
}
</style>

<style scoped lang="scss">
.listing-app {
	@include wysiwyg;
	&__heading {
		padding-bottom: 1.5rem;
		margin-bottom: 0;
	}
	p.listing-app__no-results {
		font-family: $fontFamilyHeadings;
		@include fluid(font-size, 1.5rem, 1.875rem);
		@include fluid(line-height, 30px, 38px);
		text-align: center;
		padding: 2rem 1rem;
	}
}
.narrow {
	max-width: 49rem;
	margin: 0 auto;
}
</style>